import ajax from './ajax'
import { jstLogEvent } from '@/utils/logger'

const minSize = 20 * 1024 * 1024
const maxSize = minSize * 2
export default function checkDataIsBig(data, apiName = '') {
    try {
        const dataStr = JSON.stringify(data)
        if ('TextEncoder' in window) {
            const encoder = new TextEncoder()
            const encoded = encoder.encode(dataStr)
            const byteSize = encoded.length

            if (byteSize > minSize && byteSize < maxSize) {
                const blob = new Blob([encoded], { type: 'text/plain' })

                ajax({
                    file: blob,
                    fileSuffix: '.txt',
                    onSuccess(res) {
                        const { url } = res
                        jstLogEvent({
                            element: 'check_data_is_big',
                            args: {
                                apiName,
                                byteSize,
                                url
                            }
                        })
                    },
                    onError() {
                        jstLogEvent({
                            element: 'check_data_is_big',
                            args: {
                                apiName,
                                byteSize,
                                url: `upload fail`
                            }
                        })
                    }
                })
            }
        }
    } catch (e) {
        console.error(e)
    }
}
